import { esusApi } from "@/services/api";

export type ResumeIndicatorB3Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB3Data {
	totalToothExtractionProcedures: number = 0;
	totalProcedures: number = 0;
}

export async function getResumeIndicatorB3({ uf, ibgeCode, ...params }: ResumeIndicatorB3Params) {
	const response = await esusApi.get<ResumeIndicatorB3Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b3/resume`,
		params
	);
	return response.data || new ResumeIndicatorB3Data();
}
